var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.showToolTip)?_c('el-tooltip',{staticClass:"item",attrs:{"placement":"left-start"}},[_c('div',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.showAllAgencyCodes)},slot:"content"}),_c('div',[_vm._v(_vm._s(_vm.userCode))])]):_c('div',[_vm._v(_vm._s(_vm.userCode))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }